<template>
    <vx-table-row :class="{
        'border-rose-300! bg-rose-50!': setupRequired,
    }">
        <vx-table-row-title>
            <vx-badge v-if="setupRequired" color="rose" size="xs">Setup Required <font-awesome-icon widthAuto :icon="faAsterisk" class="text-rose-500" /></vx-badge>
            <template v-else>
                {{ props.modelValue.name }}
            </template>
        </vx-table-row-title>

        <vx-table-row-item>
            <template v-slot:label> External ID: </template>
            <span class="break-all">{{ props.modelValue.group_id }}</span>
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> Users: </template>
            <vx-icon-loading v-if="loadingUsersCount" spin></vx-icon-loading>
            <span v-else>{{ usersCount }}</span>
        </vx-table-row-item>

        <vx-table-row-item>
            <template v-slot:label> OU: </template>
            <vx-popover v-if="props.modelValue.org_unit?.name" hover :arrow="true" placement="top">
                <font-awesome-icon widthAuto :icon="faBuildingFlag"></font-awesome-icon>
                <template v-slot:content>
                    <span class="text-sm font-normal">{{ props.modelValue.org_unit.name }}</span>
                </template>
            </vx-popover>
        </vx-table-row-item>

        <vx-table-row-buttons v-if="isAdminOrOwner">
            <vx-dropdown v-if="!setupRequired" placement="right">
                <vx-button data-test="dropdown"
                    type="button"
                    :color="setupRequired ? 'danger' : 'muted'"
                    outline
                    class="w-[45px]">
                    <font-awesome-icon widthAuto :icon="faEllipsis" />
                </vx-button>

                <template v-slot:items>
                    <vx-dropdown-item data-test="delete"
                        @click="deleteGroup()">
                        Delete
                        <font-awesome-icon widthAuto :icon="faTrash"></font-awesome-icon>
                    </vx-dropdown-item>
                </template>
            </vx-dropdown>

            <vx-button :href="setupRequired ? `/settings/teams/${props.modelValue.team_id}/groups/new?setup_group_id=${props.modelValue.group_id}` : `/settings/teams/${props.modelValue.team_id}/groups/${props.modelValue.group_id}`"
                data-test="edit"
                :color="!props.modelValue.name ? 'danger' : 'muted'"
                :outline="!setupRequired">
                {{ setupRequired ? 'Setup' : 'Edit' }} <font-awesome-icon widthAuto :icon="faFilePen" />
            </vx-button>
        </vx-table-row-buttons>

    </vx-table-row>
</template>

<script setup>
import {
    faAsterisk, faBuildingFlag,
    faEllipsis,
    faFilePen,
    faTrash,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    VxBadge,
    VxButton,
    VxDropdown,
    VxDropdownItem,
    VxIconLoading,
    VxPopover,
    VxSwal,
    VxTableRow,
    VxTableRowButtons,
    VxTableRowItem,
    VxTableRowTitle,
} from '@voxie/frontend-components';
import { computed , ref } from "vue";
import { groupsClient, groupUsersClient } from "~/services";
import { throwSwalRequestError } from "~/utils/request";

const isAdminOrOwner = Spark.isAdminOrOwner;

const props = defineProps({
    modelValue: {
        type: Object,
        required: true,
    },
});

const usersCount = ref('0');
const loadingUsersCount = ref(true)

const setupRequired = computed(() => !props.modelValue.name?.length)

const emit = defineEmits(['deleted']);

const getUsersCount = () => {
    if (setupRequired.value) {
        loadingUsersCount.value = false;
        return;
    }

    groupUsersClient
        .countGroupUsers(props.modelValue.team_id, props.modelValue.group_id)
        .then(({ data }) => {
            usersCount.value = Intl.NumberFormat('en-US').format(data.count);
        })
        .finally(() => {
            loadingUsersCount.value = false;
        });
};

const deleteGroup = () => VxSwal.confirmation(
        'Delete Group',
        'Are you sure? There is no undo.',
        'danger',
        () =>
            groupsClient.deleteGroup({ teamId: props.modelValue.team_id }, props.modelValue.group_id)
                .then(() => emit('deleted', props.modelValue.group_id))
                .catch(throwSwalRequestError)
    );


getUsersCount();

</script>
